import {Injectable} from '@angular/core';
import {ConfirmationService, MessageService} from 'primeng/api';
import {SessionService} from './session.service';
import {ActivatedRoute, Router} from '@angular/router';
import {DialogService} from 'primeng/dynamicdialog';
import {KeycloakService} from '../../../sdk/src/services/keycloak.service';
import {Oo8EventService} from '../../../sdk/src/services/oo8-event.service';

/**
 * Globals service
 */
@Injectable({
    providedIn: 'root'
})
export class GlobalsService {
    public keycloakService!: KeycloakService;
    public router!: Router;
    public activatedRoute!: ActivatedRoute;
    public messageService!: MessageService;
    public sessionService!: SessionService;
    public dialogService!: DialogService;
    public confirmationService!: ConfirmationService;
    public oo8EventService!: Oo8EventService;
}
